import Vue from 'vue'
import VueRouter from 'vue-router'

import Main from './views/main.vue'

const routes = [{
    name: 'main',
    path: '/',
    component: Main
  },
  {
    name: 'finish',
    path: '/finish',
    component: Main
  }
]
const router = new VueRouter({
    // mode: 'history',
    routes
})

export default router;
